/* eslint-disable */
export default {
  recentActivities: '最近活動',
  text: '文字訊息',
  fax: '傳真',
  voicemail: '語音訊息',
  call: '通話',
} as const;

// @key: @#@"recentActivities"@#@ @source: @#@"Recent Activities"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"voicemail"@#@ @source: @#@"Voicemail"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
